import * as utils from '../utils';
export function getDecorators(node) {
    return utils.getValueOrUndefined(node.decorators);
}
export function getDecoratorsArray(node) {
    return utils.getArray(getDecorators(node));
}

//# sourceMappingURL=decoratable.js.map
